// This code defines localizations for numbers and dates
// About the feature: http://kazupon.github.io/vue-i18n/guide/number.html
// About the formatting: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat

// The top level keys are language codes, the same as used to switch out other translations

export default {
    'nl': {
        'percentage': {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
        },
        'percentage_whole': {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
        'number_whole': {
            style: 'decimal',
            maximumFractionDigits: 0,
        },
        'money': {
            style: 'currency',
            currency: 'EUR',
            currencyDisplay: 'symbol',
            useGrouping: true,
        },
    },
    'fr': {
        'percentage': {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
        },
        'percentage_whole': {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
        'number_whole': {
            style: 'decimal',
            maximumFractionDigits: 0,
        },
        'money': {
            style: 'currency',
            currency: 'EUR',
            currencyDisplay: 'symbol',
            useGrouping: true,
        },
    },
};



// WEBPACK FOOTER //
// ./src/languages/numbers.js